module.exports = __webpack_public_path__ + "static/media/image-slider01.404e2fcf.jpg";